import { render, staticRenderFns } from "./systemSetting.vue?vue&type=template&id=37a2e5fa"
import script from "./systemSetting.vue?vue&type=script&lang=js"
export * from "./systemSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports